// extracted by mini-css-extract-plugin
export var eventImage = "item-module--eventImage--QFF6g";
export var eventLocationWrapper = "item-module--eventLocationWrapper--kPdja";
export var flexGrow = "item-module--flexGrow--7OYlU";
export var image = "item-module--image--6fIMR";
export var inner = "item-module--inner--I6+4V";
export var item = "item-module--item--XpRm8";
export var label = "item-module--label--zEDBe";
export var sbShowMain = "item-module--sb-show-main--Q0AHl";
export var text = "item-module--text--++qHd";
export var title = "item-module--title--6K+nQ";